class ProductCarouselSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Navigation }) => {

      var data_id = this.getAttribute('data-id');
      console.log("."+data_id+"[data-next]");
      const swiperParams = {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 8,
        speed: 400,
        navigation: {
          nextEl: "."+data_id+"[data-next]",
          prevEl: "."+data_id+"[data-previous]",
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
          1366: {
            slidesPerView: 4,
          },
          1920: {
            slidesPerView: 5,
          },
        },
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy();
  }
}

if (!customElements.get("product-carousel-section")) {
  customElements.define("product-carousel-section", ProductCarouselSection);
}
